import React from "react";
import { toPercentStyle } from "./resultConfig";

const value = (v) => v || "";

export default function OverlayResultBox({
    pos,
    type = "row",

    twoD,
    threeD,

    items = [],
    twoDList = [],
    threeDList = [],

    twoDColumns = 1,
    threeDColumns = 1,

    twoDColor = "#000",
    threeDColor = "#000",

    // spacing
    rowGap = "8%",
    columnGap = "8%",
    groupGap = "10%",
    itemGap = "6%",
    groupColumns,
    itemColumns,
    rows,

    gap = "6%", // grid column gap

    rowHeight,

    // font control
    fontSize, // e.g. "clamp(6px, 3cqw, 16px)"
    twoDFontSize,
    threeDFontSize,

    className = "",
    twoDGap,
    threeDGap,
    twoDHeight,
    threeDHeight,
    values = [],
    textColor = "#000",
    columns = 1,
    valueColors = [],
    valueColumns,
    offsetY,
    lineHeight,
    fontFamily,
    fontWeight,
    letterSpacing,
    textShadow,
}) {
    const style = {
        ...toPercentStyle(pos),
        ...(fontSize ? { "--overlay-font-size": fontSize } : {}),
        ...(offsetY ? { "--overlay-offset-y": offsetY } : {}),
        ...(fontFamily ? { fontFamily } : {}),
        ...(fontWeight ? { "--overlay-font-weight": fontWeight } : {}),
        ...(letterSpacing ? { "--overlay-letter-spacing": letterSpacing } : {}),
        ...(lineHeight ? { "--overlay-line-height": lineHeight } : {}),
        ...(textShadow ? { textShadow } : {}),
    };

    const valueColumnTemplate = Array.isArray(valueColumns)
        ? valueColumns.join(" ")
        : valueColumns;
    const pairListRowCount = Math.max(items.length, 1);
    const pairColumnRowCount = Math.max(rows || items.length, 1);
    return (
        <div className={`overlay ${className}`} style={style}>
            {/* ================= LO (vertical list) ================= */}
            {type === "pair-list" && (
                <div
                    className="or-pair-list"
                    style={{
                        rowGap,
                        ...(rowHeight
                            ? {}
                            : {
                                  gridTemplateRows: `repeat(${pairListRowCount}, minmax(0, 1fr))`,
                              }),
                    }}
                >
                    {items.map((it, i) => (
                        <div
                            key={i}
                            className="or-pair-list-row"
                            style={{
                                height: rowHeight || "auto",
                                columnGap,
                            }}
                        >
                            <span style={{ color: twoDColor }}>{value(it.twoD)}</span>
                            <span style={{ color: threeDColor }}>{value(it.threeD)}</span>
                        </div>
                    ))}
                </div>
            )}

            {type === "value-grid" && (
                <div
                    className="or-value-grid"
                    style={{
                        rowGap,
                        columnGap,
                        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
                        ...(rowHeight ? { gridAutoRows: rowHeight } : {}),
                    }}
                >
                    {values.map((item, i) => (
                        <div
                            key={i}
                            className="or-value-grid-row"
                            style={{
                                height: rowHeight || "auto",
                                color: textColor,
                            }}
                        >
                            <span>{value(item.value)}</span>
                        </div>
                    ))}
                </div>
            )}

            {/* ================= B C D (vertical pairs) ================= */}
            {type === "pair-column" && (
                <div
                    className="or-pair-column"
                    style={{
                        rowGap,
                        ...((rows || items.length)
                            ? {
                                  gridTemplateRows: `repeat(${pairColumnRowCount}, minmax(0, 1fr))`,
                              }
                            : {}),
                    }}
                >
                    {items.map((it, i) => (
                        <div
                            key={i}
                            className="or-pair-row"
                            style={{
                                height: rowHeight || "auto",
                                columnGap,
                            }}
                        >
                            <span style={{ color: twoDColor }}>{value(it.twoD)}</span>
                            <span style={{ color: threeDColor }}>{value(it.threeD)}</span>
                        </div>
                    ))}
                </div>
            )}

            {/* ================= A F I (horizontal groups) ================= */}
            {type === "multi-row" && (
                <div
                    className="or-multi-row"
                    style={
                        groupColumns
                            ? {
                                  display: "grid",
                                  gridTemplateColumns: `repeat(${groupColumns}, minmax(0, 1fr))`,
                                  columnGap: groupGap,
                              }
                            : { columnGap: groupGap }
                    }
                >
                    {items.map((item, i) => (
                        <div
                            key={i}
                            className="or-multi-item"
                            style={
                                itemColumns
                                    ? {
                                          display: "grid",
                                          gridTemplateColumns: `repeat(${itemColumns}, minmax(0, 1fr))`,
                                          columnGap: itemGap,
                                      }
                                    : { columnGap: itemGap }
                            }
                        >
                            <span style={{ color: twoDColor }}>{value(item.twoD)}</span>
                            <span style={{ color: threeDColor }}>{value(item.threeD)}</span>
                        </div>
                    ))}
                </div>
            )}

            {/* ================= NORMAL ROW ================= */}
            {type === "row" && (
                <div className="or-row">
                    <span style={{ color: twoDColor }}>{value(twoD)}</span>
                    <span style={{ color: threeDColor }}>{value(threeD)}</span>
                </div>
            )}

            {type === "value-row" && (
                <div
                    className="or-value-row"
                    style={{
                        gridTemplateColumns:
                            valueColumnTemplate ||
                            `repeat(${values.length || 1}, minmax(0, 1fr))`,
                        columnGap,
                    }}
                >
                    {values.map((item, index) => (
                        <span
                            key={index}
                            style={{ color: valueColors[index] || textColor }}
                        >
                            {value(item)}
                        </span>
                    ))}
                </div>
            )}

            {/* ================= COLUMN ================= */}
            {type === "column" && (
                <div className="or-column">
                    <span style={{ color: twoDColor }}>{value(twoD)}</span>
                    <span style={{ color: threeDColor }}>{value(threeD)}</span>
                </div>
            )}

            {/* ================= GRID (A block) ================= */}
            {type === "grid" && (
                <div className="or-grid" style={{rowGap}}>
                    <div
                        className="or-grid-line"
                        style={{
                            gridTemplateColumns: `repeat(${twoDColumns}, 1fr)`,
                            columnGap: twoDGap || gap,
                            height: rowHeight,
                        }}
                    >
                        {twoDList.map((v, i) => (
                            <span key={i} style={{ color: twoDColor }}>
                                {value(v)}
                            </span>
                        ))}
                    </div>

                    <div
                        className="or-grid-line"
                        style={{
                            gridTemplateColumns: `repeat(${threeDColumns}, 1fr)`,
                            columnGap: threeDGap || gap,
                            height: rowHeight,
                        }}
                    >
                        {threeDList.map((v, i) => (
                            <span key={i} style={{ color: threeDColor }}>
                                {value(v)}
                            </span>
                        ))}
                    </div>
                </div>
            )}

            {type === "a-group" && (
                <div
                    className="or-a-group"
                    style={{
                        gridTemplateRows: `${twoDHeight || "1fr"} ${threeDHeight || "1fr"}`,
                        rowGap: rowGap || "10%",
                    }}
                >
                    <div
                        className="or-a-line"
                        style={{
                            gridTemplateColumns: `repeat(${twoDColumns || 4}, 1fr)`,
                            columnGap: twoDGap || gap || "4%",
                        }}
                    >
                        {twoDList.map((v, i) => (
                            <span
                                key={`2d-${i}`}
                                style={{
                                    color: twoDColor,
                                    ...(twoDFontSize
                                        ? { fontSize: twoDFontSize }
                                        : {}),
                                }}
                            >
                                {value(v)}
                            </span>
                        ))}
                    </div>

                    <div
                        className="or-a-line"
                        style={{
                            gridTemplateColumns: `repeat(${threeDColumns || 3}, 1fr)`,
                            columnGap: threeDGap || gap || "6%",
                        }}
                    >
                        {threeDList.map((v, i) => (
                            <span
                                key={`3d-${i}`}
                                style={{
                                    color: threeDColor,
                                    ...(threeDFontSize
                                        ? { fontSize: threeDFontSize }
                                        : {}),
                                }}
                            >
                                {value(v)}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
